export default __webpack_public_path__ + "static/media/DefectLogoSpin.7c75680d.gif";